var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.7568 71.0201C84.8179 70.764 85.1821 70.764 85.2432 71.0201L85.8876 73.7229C86.2063 75.0599 87.278 76.0865 88.6274 76.3475L90.7312 76.7546C91.0013 76.8068 91.0013 77.1932 90.7312 77.2454L88.6274 77.6525C87.278 77.9135 86.2063 78.9401 85.8876 80.2771L85.2432 82.9799C85.1821 83.236 84.8179 83.236 84.7568 82.9799L84.1124 80.2771C83.7937 78.9401 82.722 77.9135 81.3726 77.6525L79.2688 77.2454C78.9987 77.1932 78.9987 76.8068 79.2688 76.7546L81.3726 76.3475C82.722 76.0865 83.7937 75.0599 84.1124 73.7229L84.7568 71.0201Z",
    fill: "url(#paint0_linear_45185_10380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8262 37.9951C75.8502 37.7887 76.1498 37.7887 76.1738 37.9951L76.2032 38.2475C76.293 39.02 76.8819 39.6406 77.6487 39.7707L77.9833 39.8275C78.1776 39.8604 78.1776 40.1396 77.9833 40.1725L77.6487 40.2293C76.8819 40.3594 76.293 40.98 76.2032 41.7525L76.1738 42.0049C76.1498 42.2113 75.8502 42.2113 75.8262 42.0049L75.7968 41.7525C75.707 40.98 75.1181 40.3594 74.3513 40.2293L74.0167 40.1725C73.8224 40.1396 73.8224 39.8604 74.0167 39.8275L74.3513 39.7707C75.1181 39.6406 75.707 39.02 75.7968 38.2475L75.8262 37.9951Z",
    fill: "url(#paint1_linear_45185_10380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45185_10380",
    x1: 85,
    y1: 69.7742,
    x2: 85,
    y2: 84.2258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_45185_10380",
    x1: 76,
    y1: 37,
    x2: 76,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56DB53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1968B0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/star-3.6ec0d72a20c3ceecb487cbeb654ed754.svg";
export { ForwardRef as ReactComponent };